export default __webpack_public_path__ + "assets/5GreyCat.png";